import { connect } from "react-redux";

import { shouldRenderPagination } from "../../state/selectors";
import { getPaginationData } from "../../state/modules/search";
import { getCanonicalUrlFromCategoryDetailsByLocale } from "../../state/modules/category/selectors";
import { withTranslation } from "../../components/translation";
import Pagination from "../../components/Pagination";

const mapStateToProps = state => {
  const {
    page: { initial, max }
  } = getPaginationData(state);

  return {
    shouldRender: shouldRenderPagination(state),
    currentPage: initial,
    maxPage: max,
    url: getCanonicalUrlFromCategoryDetailsByLocale(state)
  };
};

export default connect(mapStateToProps)(withTranslation(Pagination));
